import React, { useEffect, useState } from "react";
import Footerweb from "../../components/layout/footer/Footerweb";
import {
  buttonName,
  commonValidationMsg,
  emailTemplateGocardless,
  fieldValidation,
  mail,
  responseStatus
} from "../../locales/en";
import "./templateMail.scss";
import { useSearchParams } from "react-router-dom";
import {
  FaFile,
  FaFilePdf,
  FaFileImage,
  FaRegFileWord,
  FaFileExcel
} from "react-icons/fa";
import publicAxios from "../../utils/publicAxios";
import DatePickerWithText from "../../components/datepicker/DatePickerWithText";
import {
  getEmailTemplateCaptureUrl,
  getEmailTemplatedayPaymentUrl
} from "../../utils/constants/apiEndPoints";
import { TEMPLATE_PAYMENT_DATA } from "../../utils/data/data";
import Headerweb from "../../components/layout/header/Headerweb";
import { showToast, sanitizeInput } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";

const DateForPayment = () => {
  const [paymentDate, setPaymentDate] = useState(null);
  const [comment, setComment] = useState("");
  const [fileData, setFileData] = useState(null);
  const [fileError, setFileError] = useState("");
  const [dateError, setDateError] = useState("");
  const [getData, setGetData] = useState({});
  const [dataError, setDataError] = useState(false);
  const [showInfoMessage, setShowInfoMessage] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [showFile, setShowFile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [FileIcon, setFileIcon] = useState(() => FaFile);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("uuid");
  const UUIDNumber = getData?.uuid;

  const handleDateChange = (date) => {
    setPaymentDate(date);
    if (date) {
      setDateError("");
      const today = new Date();
      setShowFile(true);
      const diffDays = Math.ceil(
        (date.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
      );
      if (diffDays > 4) {
        setShowInfoMessage(true);
      } else if (diffDays <= 4) {
        setShowInfoMessage(false);
      }
    }
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const maxSize = 5 * 1024 * 1024;

    if (file) {
      if (file.size > maxSize) {
        setFileError(commonValidationMsg?.fileLimitError);
        setFileData(null);
        setFileIcon(() => FaFile);
      } else {
        setFileError("");
        setFileData(file);
        // choose icon dynamically
        if (file.type.includes("pdf")) setFileIcon(() => FaFilePdf);
        else if (file.type.includes("image")) setFileIcon(() => FaFileImage);
        else if (file.type.includes("word")) setFileIcon(() => FaRegFileWord);
        else if (file.type.includes("excel")) setFileIcon(() => FaFileExcel);
        else setFileIcon(() => FaFile);
      }
    }
  };

  const handleSubmit = async () => {
    let hasError = false;

    if (!paymentDate) {
      setDateError(fieldValidation?.required);
      hasError = true;
    }

    if (fileError) {
      hasError = true;
    }

    if (hasError) {
      return;
    }

    try {
      setUploadLoading(true);
      const form = new FormData();
      if (fileData) form.append("evidenceFile", fileData);
      const isoDate = new Date(paymentDate).toISOString();
      form.append("proposedPaymentDate", isoDate);
      form.append("comment", comment || "");
      const res = await publicAxios.post(
        getEmailTemplatedayPaymentUrl(UUIDNumber),
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
      showToast(res?.data?.data?.message, responseStatus?.success);
    } catch (error) {
      showToast(error?.response?.data?.errors, responseStatus?.error);
    } finally {
      setUploadLoading(false);
    }
  };

  useEffect(() => {
    const handleGetPayNow = async () => {
      try {
        setLoading(true);
        setDataError(false);
        const response = await publicAxios.get(
          getEmailTemplatedayPaymentUrl(token)
        );
        const responseData = response?.data?.data;
        setGetData(responseData);
        setPaymentDate(responseData?.proposedPaymentDate);
        setComment(responseData?.comment);
      } catch (error) {
        if (error.response) {
          setDataError(true);
        }
      } finally {
        setLoading(false);
      }
    };
    handleGetPayNow();
  }, []);

  useEffect(() => {
    const handleGetPayNow = async () => {
      try {
        const payload = {
          referrer: "date_for_payment"
        };
        await publicAxios.post(getEmailTemplateCaptureUrl(UUIDNumber), payload);
      } catch (error) {
        showToast(error?.response?.data?.message, showToastType.error);
      }
    };
    if (getData && getData?.uuid) {
      handleGetPayNow();
    }
  }, [getData]);

  if (loading) {
    return (
      <div className="spinner-wrap bg-light loader_absolute">
        <div className="spinner-border custom-spinner-color" />
      </div>
    );
  }

  return (
    <div className="date-for-payment-wrap">
      <Headerweb />
      <div className="refrral-banner-section" />
      {dataError ? (
        <div className="row justify-content-center">
          <div className="col-md-8 pb-3 pt-3">
            <div className="date-for-payment-box mb-4">
              <h3 className="mb-3">
                {emailTemplateGocardless?.paymentNow?.errorTitle}
              </h3>
              <p>
                {`${emailTemplateGocardless?.paymentNow?.errorText} `}
                <a href={`mailto:${mail}`}>{mail}</a>
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="container mt-5 mb-5">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="date-for-payment-box mb-4">
                <h1 className="mb-3">
                  {emailTemplateGocardless?.dateForPayment?.title}
                </h1>
                <p>{emailTemplateGocardless?.dateForPayment?.text1}</p>
              </div>

              <div className="date-for-payment-box mb-3">
                <label htmlFor="paymentdate" className="form-label">
                  {emailTemplateGocardless?.dateForPayment?.paymentDateLabel}
                </label>
                <div className="formInput">
                  <DatePickerWithText
                    placeholder={
                      emailTemplateGocardless?.dateForPayment
                        ?.paymentDatePlaceHolder
                    }
                    value={paymentDate}
                    onChange={handleDateChange}
                    minDate={
                      new Date(new Date().setDate(new Date().getDate() + 1))
                    }
                    maxDate={
                      new Date(new Date().setDate(new Date().getDate() + 60))
                    }
                  />
                  <p className="text-secondary mt-2">
                    {emailTemplateGocardless?.dateForPayment?.infoText}
                  </p>
                  {dateError && <p className="text-danger mt-2">{dateError}</p>}
                </div>
                {showInfoMessage && (
                  <div className="formInput alert-message p-3">
                    <h2>
                      {emailTemplateGocardless?.dateForPayment?.infoTitle}
                    </h2>
                    {TEMPLATE_PAYMENT_DATA.map((item) => (
                      <p key={item.id}>{item.text}</p>
                    ))}
                  </div>
                )}
              </div>

              {paymentDate && showFile && (
                <div className="date-for-payment-box mb-3">
                  <div className="formInput">
                    <input
                      type="file"
                      id="fileUpload"
                      name="file"
                      accept="image/*,.pdf,.doc,.docx"
                      onChange={handleFileChange}
                    />
                    {fileData && (
                      <p className="d-flex align-items-center text-success mt-2">
                        <FileIcon className="me-1" />
                        {fileData.name}
                      </p>
                    )}
                    {fileError && (
                      <p className="text-danger mt-2">{fileError}</p>
                    )}
                  </div>
                </div>
              )}

              <div className="date-for-payment-box mb-3">
                <label
                  htmlFor="expectedPaymentDateComment"
                  className="form-label"
                >
                  {
                    emailTemplateGocardless?.dateForPayment
                      ?.paymentCommentPlaceLabel
                  }
                </label>
                <div className="formInput">
                  <textarea
                    className="form-control"
                    id="expectedPaymentDateComment"
                    name="comment"
                    placeholder={
                      emailTemplateGocardless?.dateForPayment
                        ?.paymentCommentPlaceHolder
                    }
                    value={comment}
                    onChange={handleCommentChange}
                  />
                </div>
              </div>

              <div className="date-for-payment-box mb-3">
                <button
                  onClick={handleSubmit}
                  className="btn btn-primary submit"
                  type="button"
                >
                  {uploadLoading ? buttonName?.loading : buttonName?.submit}
                </button>
              </div>

              <div className="date-for-payment-box mb-3">
                <p>
                  {`${emailTemplateGocardless?.dateForPayment?.text2} `}
                  <a href={`mailto:${mail}`}>{mail}</a>,
                  {` ${emailTemplateGocardless?.dateForPayment?.text3}`} <br />
                  {`${emailTemplateGocardless?.dateForPayment?.text4} `}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: sanitizeInput(getData?.phoneNumber)
                    }}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      <Footerweb />
    </div>
  );
};

export default DateForPayment;
